import { forwardRef } from "react";

import classNames from "shared/utils/classNames";

type Props = {
  isIframe: boolean;
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  onKeyDown?: (evt: React.KeyboardEvent<HTMLTextAreaElement>) => void;
};

const TextInput = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
  const {
    isIframe,
    value,
    onChange,
    placeholder,
    maxLength,
    onKeyDown,
    ...rest
  } = props;

  return (
    <textarea
      ref={ref}
      maxLength={maxLength}
      className={classNames(
        "box-border max-h-28 w-full resize-none appearance-none rounded-lg border border-solid border-grey-1 p-2.5 pr-35 outline-none",
        isIframe
          ? "text-base placeholder:text-base"
          : "text-sm placeholder:text-sm ",
      )}
      placeholder={placeholder || ""}
      onChange={evt => onChange(evt.target.value)}
      value={value}
      rows={1}
      onKeyDown={onKeyDown}
      {...rest}
    />
  );
});

TextInput.displayName = "TextAreaInput";

export default TextInput;
